import confetti from "canvas-confetti";
import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Container } from "reactstrap";
const Step10 = () => {
    const launchConfetti =()=>{
        confetti({
            particleCount:200,
            spread:170,
            origin:{y:0.6},
        });
    }
    useEffect(()=>{
        launchConfetti();
    },[])
    const [percentage, setPercentage] = useState(0);

    return (
        <React.Fragment>
            {/* Inline styles using the <style> tag */}
            <style>
                {`
                input[type="range"] {
                  -webkit-appearance: none;
                  width: 100%;
                  height: 12px;
                  background: #77bc4b;
                  border-radius: 5px;
                  outline: none;
                  transition: 0.3s;
                }

                input[type="range"]::-webkit-slider-runnable-track {
                  width: 100%;
                  height: 6px;
                  background: #77bc4b;
                  border-radius: 5px;
                }

                input[type="range"]::-moz-range-track {
                  width: 100%;
                  height: 6px;
                  background: #77bc4b;
                  border-radius: 5px;
                }

                input[type="range"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  width: 20px;
                  height: 20px;
                  background: white;
                  border: 2px solid #77bc4b;
                  border-radius: 50%;
                  cursor: pointer;
                  margin-top: -7px;
                }

                input[type="range"]::-moz-range-thumb {
                  width: 20px;
                  height: 20px;
                  background: white;
                  border: 2px solid #77bc4b;
                  border-radius: 50%;
                  cursor: pointer;
                }
                `}
            </style>

           
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={8} xl={12}>
                            <Card className="overflow-hidden">
                                <CardBody className="p-4">
                                    <div className="p-3">
                                        <form className="mt-4" action="#">
                                            <div className="mb-3">
                                                <label className="form-label" htmlFor="range">
                                                    What percentage of your motor vehicle expenses are directly related to business operations?
                                                </label>
                                                <input
                                                    type="range"
                                                    className="form-range"
                                                    min="0"
                                                    max="100"
                                                    step="25"
                                                    value={percentage}
                                                    onChange={(e) => setPercentage(Number(e.target.value))}
                                                />
                                                <div className="text-center mt-1">{percentage}%</div>
                                            </div>
                                        </form>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Step10;
